import { combineReducers, Reducer } from "redux";
import { connectRouter } from "connected-react-router";
import { History } from "history";
import storage from "redux-persist/lib/storage/session";
import { persistReducer } from "redux-persist";

import { Action } from "@ctra/utils";

import { EnterpriseAppState } from "./state";

/**
 * @todo import new reducers here
 */
import async from "../modules/async";
import auth from "../modules/auth";
import farms from "../modules/farms";
import breadcrumbs from "../modules/breadcrumbs";
import users from "../modules/user";
import dataDictionary from "../modules/data-dictionary";
import charts from "../modules/chart";
import layouts from "../modules/layouts";
import gamePlans from "../modules/game-plans";
import scorecard from "../modules/scorecard";
import herdGroups from "../modules/herd-groups";
import pens from "../modules/pens";
import dimGroups from "../modules/dim-groups";
import insights, { settingsReducer as insightSettings } from "../modules/insights";
import cows from "../modules/cows";
import preferences from "../modules/preferences";
import askIda from "../modules/ask-ida";
import events from "../modules/events";
import favourites from "../modules/favourites";
import savedCharts from "../modules/saved-charts";
import impactTracking from "../modules/impact-tracking";
import invitations from "../modules/invitation";
import session from "../modules/session";

import { getVersion, getStorageKey } from "../utils/versioning";

/**
 * @todo bump version between releases
 */
const persistConfig = {
  version: getVersion(),
  key: getStorageKey("enterprise"),
  blacklist: ["auth", "async", "navigation", "session"],
  storage
};

export default (history: History): Reducer =>
  persistReducer<EnterpriseAppState, Action>(
    persistConfig,
    /**
     * @todo add new reducers here
     */
    combineReducers<EnterpriseAppState, Action>({
      router: connectRouter(history),
      // @ts-ignore - not an issue, just inconsistency between the original and our Reducer types
      session,
      cows,
      askIda,
      async,
      dataDictionary,
      charts,
      layouts,
      gamePlans,
      // @ts-ignore - not an issue, just inconsistency between the original and our Reducer types
      auth,
      users,
      herdGroups,
      pens,
      dimGroups,
      navigation: combineReducers({
        breadcrumbs
      }),
      farms,
      scorecard,
      insights,
      // @ts-ignore - not an issue, just inconsistency between the original and our Reducer types
      settings: combineReducers({
        insights: insightSettings
      }),
      preferences,
      events,
      favourites,
      savedCharts,
      impactTracking,
      invitations
    })
  );
